<div class="grid grid-nogutter flex justify-content-center align-items-center">
    <div class="col-12">
        <div class="divider-line"></div>
    </div>
</div>